<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Multiselect from "vue-multiselect";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: { ckeditor: CKEditor.component , Multiselect },
  props: {
    // showModal: {
    //   type: Boolean,
    //   default: false
    // },
    totalEmails: {
      type: Number,
      default: 0
      // default: () => {
      //   return ""
      // },
    },
    totalSentEmails: {
      type: Number,
      default: 0
      // default: () => {
      //   return ""
      // },
    },
  },
  data() {
    return {
      editor: ClassicEditor,
      users: null,
      sendEmailForm: {
        subject: "",
        description: "<p>Content of the editor.</p>",
        receiver_id: null,
      },
      typeSubmit: false,
      showModal: false,
      isEmails: false,
      isSentEmails: false,
    };
  },
  mounted(){
    this.getUsers();
  },
  methods:{

    getUsers(){
      axios.get('admin/users?pagination=true&per_page=1000').then(res =>{
        // if (Object.keys( this.emailDataObj ).length > 0){
        //   this.users = this.emailDataObj.sender;
        //   this.sendEmailForm.subject = this.emailDataObj.subject
        //   this.sendEmailForm.description = this.emailDataObj.description
        //   let selectedUserIds = [];
        //   this.emailDataObj.receiver.map(function(value) {
        //     console.log(value)
        //     selectedUserIds.push(value.id);
        //   });
        //   this.sendEmailForm.receiver_id = selectedUserIds;
        // }
        // else {
        // }
        this.users = res.data.response.data;
      })
    },

    sendEmail() {
      this.getUsers();
      let selectedUserIds = [];
      this.sendEmailForm.receiver_id.map(function(value) {
        selectedUserIds.push(value.id);
      });
      this.sendEmailForm.receiver_id = selectedUserIds;
      // this.typesubmit = true;
      // this.$v.$touch();
      // if (!this.$v.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          axios.post('admin/notifications', this.sendEmailForm, config)
              .then((res) => {
                if (res.status == '200'){
                  Swal.fire({
                    title: "Success!",
                    text:"Email Sent successfully!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  this.showModal = false;
                  this.sendEmailForm = {
                    subject: "",
                    description: "<p>Content of the editor.</p>",
                    receiver_id: null,
                  }
                }
              })
              .catch((err) => {
                if (err.response) {
                  Swal.fire({
                    title: "Error!",
                    text: err.response.data.error.message,
                    icon: "danger",
                    width: 350,
                    showConfirmButton: true
                  });
                }
              })
        }
      // }

    },

    addActiveClass(type){
      console.log('type');
      console.log(type);
    },
  }
};
</script>

<template>
  <div class="email-leftbar card">
    <b-button variant="danger" @click="showModal = true">Compose</b-button>
    <div class="mail-list mt-4">
      <router-link tag="a" @click="addActiveClass('mail')" :to="{name: 'emails'}" :class="isEmails ? 'active' : ''">
        <i class="mdi mdi-email-outline me-2"></i> Inbox
<!--        <span class="ms-1 float-end">({{this.totalEmails}})</span>-->
      </router-link>
<!--      <router-link tag="a" :to="{name: 'emails'}">
        <i class="mdi mdi-file-outline me-2"></i>Draft
      </router-link>-->
      <router-link tag="a" @click="addActiveClass('sentmail')" :to="{name: 'sentmail'}" :class="isSentEmails ? 'active' : ''">
        <i class="mdi mdi-email-check-outline me-2"></i>Sent Mail
<!--        <span class="ms-1 float-end">({{this.totalSentEmails}})</span>-->
      </router-link>
<!--      <router-link tag="a" :to="{name: 'emails'}">
        <i class="mdi mdi-trash-can-outline me-2"></i>Trash
      </router-link>-->
    </div>

    <b-modal v-model="showModal" title="User New Email" centered>
      <form>

        <div class="mb-3">
          <multiselect v-model="sendEmailForm.receiver_id" :options="users"
                       :multiple="true"
                       track-by="username"
                       label="username"
          ></multiselect>
        </div>

<!--        <div class="mb-3">-->
<!--          <input type="email" class="form-control" placeholder="To" />-->
<!--        </div>-->

        <div class="mb-3">
          <input type="text" v-model="sendEmailForm.subject" class="form-control" placeholder="Subject" />
        </div>
        <div class="mb-3">
          <ckeditor v-model="sendEmailForm.description" :editor="editor"></ckeditor>
        </div>
      </form>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="showModal = false">Close</b-button>
        <b-button @click="sendEmail" variant="primary">
          Send
          <i class="fab fa-telegram-plane ms-1"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
